export const Action = {
  LOGOUT: "LOGOUT",
};

export const Mutation = {
  SET_TOKEN: "SET_TOKEN",
  LOGOUT: "LOGOUT"
};

export const Getter = {
  IS_AUTHENTICATED: "IS_AUTHENTICATED",
  GET_TOKEN: "GET_TOKEN"
};
